import { Component } from '@angular/core';
import { LcsChipGridComponentBase } from 'src/app/common-components/chip-grid/chip-grid';
import { RoleOption } from 'src/app/pages/role-register/models/role-option.interface';

@Component({
    selector: 'ndt-roles-chip-grid',
    templateUrl: 'role-chip-grid.component.html',
    standalone: false
})
export class RoleChipGridComponent extends LcsChipGridComponentBase<RoleOption> {
   trackBy(item: RoleOption | null) {
      return item?.roleId;
   }
}
